import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import StockDetailChart from "../Components/StockDetailChart";

import TimeControl from "../Components/TimeControl";
import IndicatorSelector from "../Components/IndicatorSelector";
import { getCompanyInformation } from "../Service/data";

import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Accordion, AccordionSummary, AccordionDetails, Stack } from "@mui/material";
import { getSectorCharts } from "../Service/sector_charts";
import CandleChart from "../Components/CandleChart";

const SectorChartsPage = () => {
  const theme = useTheme();
  const [sectorCharts, setSectorCharts] = useState([]);
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(180);
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getSectorCharts().then((data) => {
      setSectorCharts(data);
    });
  }, []);

  useEffect(()=>{
    let params = new URLSearchParams(searchParams);
    const time = params.get('time');
    console.log(time);
    setCurrentTime(time);
  }, [searchParams])

  useEffect(() => {
    if (
      sectorCharts !== null &&
      sectorCharts !== undefined &&
      sectorCharts.length > 0
    ) {
      setNoData(false);
      setLoading(false);
    }
  }, [sectorCharts]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "10px",
        paddingRight: "30px",
        paddingTop: "20px",
        minHeight: "100vh",
        minWidth: "100vw",
        width: "fit-content",
        background: `${theme.palette.background.default}`,
      }}
    >
      <TimeControl/>
      <IndicatorSelector/>
      {loading && <CircularProgress />}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <div>
          {sectorCharts.map((sectorChart, index) => {
            return (
              <Accordion key={sectorChart.sector} defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                 {sectorChart.sector}
                </AccordionSummary>
                <AccordionDetails>
                <div style={{ display: 'flex', flexDirection: 'column' }}></div>
                  {sectorChart.symbols.map((symbol, index) => {
                    const abs = symbol['abs'];
                    const rel = symbol['rel'];
                    const id = `${index}_${abs}`;
                    return (
                      <Stack key={id} direction="row" style={{ marginBottom: '20px' }}>
                        <StockDetailChart title={abs} time={currentTime} symbol={abs} width={700} height={300}></StockDetailChart>
                        <StockDetailChart title={rel} time={currentTime} symbol={rel} width={700} height={300}></StockDetailChart>
                      </Stack>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      )}
      {/* {sectorCharts &&
        sectorCharts.forEach((sectorChart) => (
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              {sectorChart.sector}
            </AccordionSummary>
            <AccordionDetails></AccordionDetails>
          </Accordion>
        ))} */}
    </div>
  );
};

export default SectorChartsPage;
